/**
 * @typedef {Object} CustomOptionsProps
 * @property {string} [className] To add custom class to Options
 * @property {Boolean} [disabled = false] To disable/enable options conditionally
 * @property {Object | string} [value] Returns this value on selection
 * @property {Object | string} [label] Returns this label on selection
 * @property {React.ReactNode} [children] Display label for the option
 */

import React from 'react';

import { Select as SelectCore } from 'antd';

const { Option: OptionCore } = SelectCore;
/**
 * @description UI Component to display the select options of form element. Underlying it is using the antd select option component.
 *
 * @author  Hemant Kumar Goyal <@hemantkumar.goyal>
 *
 * @reference https://ant.design/components/select#option-props
 *
 * @param {CustomOptionsProps}  props https://ant.design/components/select#option-props
 *
 * @returns {React.component}
 */

const Option = (props) => {
	const { children, ...restProps } = props;

	return <OptionCore {...restProps}>{children}</OptionCore>;
};

export default Option;
